export const HOMEIMAGES = {
  PORTALIMAGE: require("../../Assets/HomeImages/football.webp"),
  FOOTBALL: require("../../Assets/images/FootballImg.webp"),
  LOGO: require("../../Assets/images/logo.png"),
  // PORTALIMAGE: require("../../Assets/HomeImages/portalImage.png"),
  MOTORSPORT: require("../../Assets/HomeImages/motorsport.webp"),
  RUGBY: require("../../Assets/HomeImages/rugby.webp"),
  TENNIS: require("../../Assets/HomeImages/tennis.webp"),
  BOXING: require("../../Assets/HomeImages/boxing.webp"),
  DARTS : require("../../Assets/images/darts.webp") ,
  HORSERACING : require("../../Assets/HomeImages/horseracing.webp") ,
  MOTOGP : require("../../Assets/images/motogp.webp") ,
  CRICKET : require("../../Assets/images/cricket.webp") ,
};
